import { Chip, TableCell, TableRow, Typography } from "@mui/material";

import { Div } from "themes/jumbo/@jumbo/shared";
import { IssueType } from "./types";
import { getCachedData } from "api/Cache";
import { tss } from "tss-react";
import { formatDateDetailed } from "services/UtilsService";
import { defaultThumbnailIcon } from "constants/common";
import { Scrollbars } from "react-custom-scrollbars";
import { getFileIcon } from "actions/GlobalActions";
import { ReactComponent as File } from "assets/images/file.svg";
import { icons } from "constants/viewer";

const useStyles = tss.create(() => ({
  ellipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box"
  },
  multiLineEllipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical"
  },
  tableTr: {
    " &:hover": {
      background: 'rgba(0, 0, 0, .05)',
      //cursor: 'pointer'
    }
  },
  tableTd: {
    padding: '8px 16px',
    fontSize: '0.813rem',
    " &.fixedHeight": {
      height: '57px'
    }
  },
  icon: {
    width: 27,
    height: 27,
    marginRight: 10,
    color: 'rgb(0,0,0,0.53)',
  },
  layerIcon: {
    display: "inline-flex",
    alignItems: "center",
  },
}));

const getIcon = (fileName: string, classes: any) => {
  if (!fileName) {
      return <File className={classes.icon} />;
  }
  const Icon = icons[fileName];
  return (
      <div className={classes.layerIcon}>
          <Icon className={classes.icon} />
      </div>
  );
}

const IssueItem = ({ item, index }: { item: IssueType, index: Number }) => {

  const { classes } = useStyles();
  //const { ID:projectID, name:projectName = 'Unknown Project', description:projectDescription = '', image = '', thumbnail = '', timezone } = item;
  const projects: any = getCachedData("projects");

  return (
    <TableRow
      sx={{
        "td:first-of-type": {
          pl: 3,
        },
        "td:last-child": {
          pr: 3,
        },
      }}
      className={classes.tableTr}
    >
      <TableCell className={`${classes.tableTd} fixedHeight`}>
        <Div sx={{ display: "flex", minWidth: 0, alignItems: "center" }}>
          {getIcon(item.fileName, classes)}
          <Typography variant="h5" mb={0.5} fontSize={14} className={classes.multiLineEllipsis}>
            {item.name}
          </Typography>
        </Div>
      </TableCell>
      <TableCell className={classes.tableTd}>
        <Div sx={{ display: "flex", flexDirection: "column", alignItems: "center"  }}>
          {item.workflow === null ? (
              <>
                  <Chip
                      label="..."
                      size={'small'}
                      style={{ backgroundColor: '#ffc248' }}
                  />
                  {/*<Typography variant={'body1'} fontSize={12}>{item.path }</Typography>*/}
              </>
          ) : (
              <div>
                  <Chip
                      label={`${item.workflow.version}`}
                      size={'small'}
                      style={{ backgroundColor: 'rgb(115, 173, 33)' }}
                  />
                  {/*<Typography variant={'body1'} fontSize={12}>{item.products}</Typography>*/}
              </div>
          )}
        </Div>
      </TableCell>
      <TableCell className={classes.tableTd}>
        <Div sx={{ display: "flex" }}>
          <Typography 
            variant={'body1'} 
            sx={{ fontSize: '12px !important' }} 
            color={'text.secondary'} 
            textAlign={'center'} 
            className={classes.multiLineEllipsis}
            >
              {item.projectName}
            </Typography>
        </Div>
      </TableCell>
    </TableRow>
  );
};
const EmptyIssueItem = () => {

  const { classes } = useStyles();
  return (
    <TableRow
      sx={{
        "td:first-of-type": {
          pl: 3,
        },
        "td:last-child": {
          pr: 3,
        },
      }}
    >
      <TableCell colSpan={3}>
        <Div>
          <Typography
              fontSize={'13px'}
              variant={'body1'}
              color={'text.secondary'}
              sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '50px 0', height: '310px'}}
          >
              No issue found
          </Typography>
        </Div>
      </TableCell>
    </TableRow>
  );
};
export { IssueItem, EmptyIssueItem };
